<template>
  <div class="download-section">
    <div class="download-container">
      <div class="download-content">
        <div class="download-text">
          <h3>Download GO Count Now</h3>
          <p>Simple and efficient counting tool for easier data recording</p>
          <p class="download-subtext">Available on iOS and Android platforms, free to download</p>
        </div>
        
        <div class="download-buttons">
          <a href="https://apps.apple.com/us/app/go-count-object-thing-counter/id6737248223" class="download-btn ios-btn" target="_blank" rel="noopener noreferrer">
            <div class="btn-icon">
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24" height="24">
                  <path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
                </svg>
              </span>
            </div>
            <div class="btn-text">
              <span class="small-text">Download on</span>
              <span class="large-text">App Store</span>
            </div>
          </a>
          
          <a href="https://play.google.com/store/apps/details?id=com.compute.things.counter" class="download-btn android-btn" target="_blank" rel="noopener noreferrer">
            <div class="btn-icon">
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="24" height="24">
                  <path fill="currentColor" d="M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"/>
                </svg>
              </span>
            </div>
            <div class="btn-text">
              <span class="small-text">Download on</span>
              <span class="large-text">Google Play</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadSection'
}
</script>

<style scoped>
.download-section {
  padding: 60px 20px;
  background-color: #e8f4fc;
  width: 100%;
  box-sizing: border-box;
}

.download-container {
  max-width: 900px;
  margin: 0 auto;
}

.download-content {
  background-color: white;
  border-radius: 20px;
  padding: 50px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.download-text {
  margin-bottom: 40px;
}

.download-text h3 {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 15px;
}

.download-text p {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 10px;
}

.download-subtext {
  font-size: 1rem !important;
  color: #888 !important;
}

.download-buttons {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.download-btn {
  display: flex;
  align-items: center;
  padding: 15px 30px;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 220px;
  box-sizing: border-box;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.ios-btn {
  background-color: #000;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.android-btn {
  background-color: #0F9D58;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.download-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.btn-icon {
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.9;
}

.btn-icon svg {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.btn-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.small-text {
  font-size: 0.9rem;
  margin-bottom: 2px;
  opacity: 0.85;
}

.large-text {
  font-size: 1.3rem;
  font-weight: bold;
  letter-spacing: 0.2px;
}

@media (max-width: 768px) {
  .download-section {
    padding: 40px 15px;
  }
  
  .download-content {
    padding: 30px 20px;
  }
  
  .download-text h3 {
    font-size: 1.8rem;
  }
  
  .download-text p {
    font-size: 1rem;
  }
  
  .download-buttons {
    flex-direction: column;
    gap: 15px;
    width: 100%;
    align-items: center;
  }
  
  .download-btn {
    width: 80%;
    max-width: 250px;
    justify-content: center;
    padding: 12px 20px;
  }
  
  .small-text {
    font-size: 0.8rem;
    margin-bottom: 3px;
  }
  
  .large-text {
    font-size: 1.2rem;
    letter-spacing: 0.1px;
  }
}

@media (max-width: 480px) {
  .download-section {
    padding: 30px 10px;
  }
  
  .download-content {
    padding: 25px 15px;
    border-radius: 15px;
  }
  
  .download-text {
    margin-bottom: 25px;
  }
  
  .download-text h3 {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
  
  .download-text p {
    font-size: 0.9rem;
  }
  
  .download-subtext {
    font-size: 0.8rem !important;
  }
  
  .download-btn {
    padding: 10px 15px;
    min-width: auto;
    width: 70%;
    max-width: 220px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  
  .btn-icon {
    margin-right: 10px;
    opacity: 0.95;
  }
  
  .btn-text {
    flex: 0;
    text-align: center;
    align-items: center;
  }
  
  .btn-icon svg {
    width: 20px;
    height: 20px;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1));
  }
  
  .small-text {
    font-size: 0.7rem;
    margin-bottom: 4px;
    letter-spacing: 0.3px;
  }
  
  .large-text {
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
  }
}

@media (max-width: 360px) {
  .download-btn {
    padding: 8px 12px;
    width: 80%;
    max-width: 200px;
    justify-content: center;
  }
  
  .btn-text {
    flex: 0;
    align-items: center;
  }
  
  .btn-icon svg {
    width: 18px;
    height: 18px;
  }
  
  .small-text {
    font-size: 0.65rem;
    margin-bottom: 3px;
    letter-spacing: 0.2px;
  }
  
  .large-text {
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.1px;
  }
}
</style> 